import { useContext } from "react";
import { IconButton, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { SettingsOption } from "./Settings.style";
import { useTranslation } from "hhn-commons";
import UserSettings from "../../../header/userSettings/UserSettings";
import { RightDrawerContext } from "../../../context/RightDrawerContext";
import { IGroupInfo } from "@home-health-notify/domain";

const ManageOtherNotifications = ({ groupInfo }: { groupInfo: IGroupInfo }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "groupChatInfo" });
  const { openDrawer, setContent } = useContext(RightDrawerContext);

  const openSettings = () => {
    setContent(
      <UserSettings chatId={groupInfo.id} groupType={groupInfo.groupType} />,
    );
    openDrawer();
  };

  return (
    <SettingsOption>
      <Typography>{tNs("manageNotifications")}</Typography>
      <IconButton onClick={openSettings}>
        <ArrowForwardIcon sx={{ color: "black" }} />
      </IconButton>
    </SettingsOption>
  );
};

export default ManageOtherNotifications;
